module.exports = __webpack_public_path__ + "media/add/add-2-68f01ec0.jpg";